import { useState } from "react";


const statusLabel = (status) => {
  switch (status) {
    case "completed":
      return "Completed";
    case "in_progress":
      return "In Progress";
    case "failed":
      return "Failed";
    default:
      return status;
  }
};

const SettlementEditModal = ({ settlement, onClose, onSave }) => {
  const [form, setForm] = useState({ ...settlement });

  const handleChange = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        <div className="px-6 py-4 border-b border-white/10">
          <h2 className="text-white font-semibold text-sm">Edit Settlement</h2>
          <p className="text-xs text-slate-500 mt-0.5">{settlement.settlement_id}</p>
        </div>

        <div className="px-6 py-5 space-y-4">
          <Field label="Settlement ID">
            <input
              type="text"
              value={form.settlement_id || ""}
              onChange={(e) => handleChange("settlement_id", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </Field>

          <div className="grid grid-cols-2 gap-4">
            <Field label="Settlement Date">
              <input
                type="date"
                value={form.settlement_date || ""}
                onChange={(e) => handleChange("settlement_date", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </Field>

            <Field label="Settlement Amount (€)">
              <input
                type="number"
                value={form.settlement_amount || ""}
                onChange={(e) => handleChange("settlement_amount", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </Field>
          </div>

          <Field label="Payment Status">
            <div className="grid grid-cols-3 gap-2">
              {["completed", "in_progress", "failed"].map((s) => (
                <button
                  key={s}
                  onClick={() => handleChange("payment_status", s)}
                  className={`py-2 rounded-lg text-xs font-medium capitalize border transition ${
                    form.payment_status === s
                      ? s === "completed"
                        ? "bg-emerald-500/20 border-emerald-500/50 text-emerald-400"
                        : s === "in_progress"
                        ? "bg-amber-500/20 border-amber-500/50 text-amber-400"
                        : "bg-red-500/20 border-red-500/50 text-red-400"
                      : "bg-slate-800 border-white/10 text-slate-400 hover:border-white/20 hover:text-white"
                  }`}
                >
                  {statusLabel(s)}
                </button>
              ))}
            </div>
          </Field>
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>
          <button
            onClick={() => { onSave(form); onClose(); }}
            className="px-4 py-2 text-sm rounded-lg text-white bg-pink-600 hover:bg-pink-700 transition"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettlementEditModal;

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="block text-xs text-slate-400">{label}</label>
    {children}
  </div>
);